export default "__VITE_PUBLIC_ASSET__6c9e30a9__"